<template>
    <div
        class="page-container page-container--height chat-visible"
        v-if="loggedIn"
        :class="{'sidebar-collapsed--chat' : sidebarStateRight, 'sidebar-collapsed' : sidebarStateLeft}"
    >

        <app-left-panel></app-left-panel>

        <div class="main-content main-content--wide" :class="[{'bg-grey': disableBg}, {'bg-gray--ligth': isPayerDocs}]">
            <app-header-simple></app-header-simple>
            <router-view></router-view>
        </div>

        <!--        <app-right-panel v-if="$route.name !== 'dashboard'"></app-right-panel>-->
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import LeftPanel from './LeftPanel.vue';
    // import RightPanel from './RightPanel.vue';
    import env from '../../env';
    import HeaderSimple from "../../common_components/HeaderSimple";

    export default {
        data: () => ({
            env,
            blocker: false
        }),
        computed: {
            ...mapGetters([
                'loggedInHash',
                'loggedIn',
                'sidebarStateLeft',
                'sidebarStateRight',
                'userData',
            ]),
            disableBg() {
                return this.$route.name !== 'diary' && this.$route.name !== 'profile' && this.$route.name !== 'documents' && this.$route.name !== 'student_payment' && this.$route.name !== 'history_payment'
            },
            isPayerDocs() {
                return this.$route.name === 'documents'
            }
        },
        components: {
            appHeaderSimple: HeaderSimple,
            appLeftPanel: LeftPanel,
            // appRightPanel: RightPanel,
        },
        watch: {
            loggedInHash: function (val) {
                if(!this.loggedIn){
                    this.$router.push({ name: 'login' });
                }
            },
        },

    }
</script>

<style lang="sass" scoped>
    @import "../../../sass/cabinet"
    @import "../../../sass/teacherLesson"
    @import "../../../sass/teacherCheckwork"
    @import "../../../sass/studentStat"
    @import "../../../sass/teacherMaterials"

    .bg-gray--ligth
        background-color: #FAFAFA
</style>
